import { Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import NotFound from "@/pages/NotFound";

export default function SuperuserRoute() {
  const { isSuperuser } = useAuth();

  if (!isSuperuser) {
    return <NotFound />;
  }

  return <Outlet />;
}
